import { ProgressBar } from 'devextreme-react/progress-bar'
import { useDocExportProgress } from '../../hooks/useDocExportProgress'
import './DocExportProgress.scss'

export default function DocExportProgress() {
	const { visible, phase, percent } = useDocExportProgress()

	if (!visible) {
		return null
	}
	const isPreparing = phase === 'preparing'

	const statusText = () => {
		if (phase === 'completed') {
			return 'Document export completed [ 100% ]'
		}
		if (phase === 'preparing') {
			return 'Preparing document...'
		}
		if (phase === 'downloading' && typeof percent === 'number') {
			return `Downloading document [ ${percent}% ]`
		}
		return 'Downloading document...'
	}

	const progressValue = () => {
		if (phase === 'completed') {
			return 100
		}
		if (isPreparing) {
			return 0
		}
		if (typeof percent === 'number') {
			return percent
		}
		return 0
	}

	return (
		<div className="doc-export-progress-container slide-down">
			<div className="doc-export-progress-content">
				<ProgressBar
					min={0}
					max={100}
					height={20}
					value={progressValue()}
					showStatus={true}
					statusFormat={statusText}
					className={`doc-export-progress-bar ${isPreparing ? 'is-preparing' : ''}`}
				/>
			</div>
		</div>
	)
}
